import { Factory } from 'fishery';

import { FactoryAutoRewindSequence } from './factory-auto-rewind-sequence';

import type { Pagination, PaginationCountResponse, SimplePagination } from '../data-contract/pagination';

export const paginationFactory = FactoryAutoRewindSequence.define<Pagination>(({ sequence }) => {
    const size = 20;
    const pages = sequence + 1;
    const count = pages * size;

    return {
        count,
        page: sequence,
        pages,
        size,
    };
});

export const paginationCountResponseFactory = Factory.define<PaginationCountResponse>(() => ({
    pagination: paginationFactory.build(),
}));

export const simplePaginationFactory = FactoryAutoRewindSequence.define<SimplePagination>(() => ({
    count: 100,
    page: 0,
    pages: 5,
    size: 20,
}));
